export const OPEN_MODAL_LOGIN = 'OPEN_MODAL_LOGIN';
export const CLOSE_MODAL_LOGIN = 'CLOSE_MODAL_LOGIN';

export function openModal() {
  return (dispatch, getState) => {
    let { user } = getState();

    if (!user.authenticated) {
      return dispatch({
        type: OPEN_MODAL_LOGIN
      });
    }
  }
}

export function closeModal() {
  return (dispatch, getState) => {
    return dispatch({
      type: CLOSE_MODAL_LOGIN
    });
  }
}


// WEBPACK FOOTER //
// ./src/actions/ModalLoginActions.js